import React, { useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { channels_dictionary } from '../../static/channels_dictionary';
import { PopInfo } from '../PopInfo';
import { CenterInfo } from '../UiKit/CenterInfo';
import { prepareChannels } from '../utilsDesign';
import { getPentaDesign } from '../utilsPenta';
import { ChannelInfo } from './ChannelInfo';
import { StudyGate } from './StudyGate';
import { AstroInfo } from './Astro';
import { default_design } from '../../static/default_design';
import { gates_dictionary } from '../../static/gates_dictionary';
import { JyotishInfo } from './Jyotish';

export function Study({ avatar, penta }) {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $center = context.$center;
  const $ui = context.$ui;
  const $gate = context.$gate;

  const navigate = useNavigate();
  const location = useLocation();

  const isStudy = location.pathname.includes('study');

  const { what } = useParams();

  const infoType = what ? what.split(':')[0] : null;
  let infoValue = what ? what.split(':')[1] : null;

  // console.log('infoType = ', infoType);
  // console.log('infoValue = ', infoValue);

  // let design = !penta ? JSON.parse(JSON.stringify(avatar.design)) : penta.pentaDesign || getPentaDesign(penta)
  let design = !penta 
    ? JSON.parse(JSON.stringify(avatar.design)) 
    : penta.pentaDesign || default_design;

  design = {
    ...design,
    channels: prepareChannels(design.gates)
  }

  const handleCloseInfoPop = () => {
    document.body.classList.remove('noscroll');
    context.setState.setHighlighted()
    context.setState.setSearch([])

    const removeStudySegments = (pathname) => {
      const segments = pathname.split('/study')
      return segments.length > 1 ? segments[0] : null
    };
    const currentPath = location.pathname;
    const newPath = removeStudySegments(currentPath);
    const queryParams = location.search ? location.search : '';
    if (newPath) navigate(`${newPath}${queryParams}`);
  };


  const handleClose = () => {
    // navigate('../')
    handleCloseInfoPop()
  }
  const channelProps = isStudy
    ? (channels_dictionary.find(one => one.id === infoValue) || {})
    : {};

  const gateProps = gates_dictionary[infoValue];


  const getTitle = () => {
    if (isStudy && infoType === 'astro') {
      return $ui('popinfo_astro_title')
    }
    if (isStudy && infoType === 'jyotish') {
      return $ui('popinfo_jyotish_title')
    }
    return `${what ? $center(infoValue, 'title') : ''}`
  }

  return (
    <>

      <PopInfo
        active={isStudy}
        id={`${what}_${infoValue}`}
        addClassName={isStudy ? 'active' : 'inactive'}
        type='study'
        // title={`${$center(infoValue, 'title')}`}
        title={getTitle()}
        // title={`${$ui('pop_study_title')}: ${what ? $center(infoValue, 'title') : ''}`}
        icon='info'
        handleClose={() => handleClose()}
      >


        {Boolean(infoType) &&

          <div className="x_info_c _f100">

            {isStudy && infoType === 'center' &&
              <CenterInfo
                center={infoValue}
                design={design}
              />}


            {isStudy && infoType === 'channel'
              && <>
                <ChannelInfo
                  design={design}
                  penta={penta}
                // gates={design.gates}
                  {...channelProps}
                />
              </>}

            {isStudy && infoType === 'gate'
              && <>
              <StudyGate
                design={design}
                gateId={infoValue}
                types={gateProps.types}
                circuit={gateProps.circuit}
                stream={gateProps.stream}
                penta={penta}
              />
              </>}

            {isStudy && infoType === 'astro'
              && <>
              <AstroInfo
                avatar={avatar}
              />
            </>}

            {isStudy && infoType === 'jyotish'
              && <>
              <JyotishInfo
                avatar={avatar}
              />
            </>}

          </div>
        }
      </PopInfo>
    </>
  )
}



